import api from './api.service';

function unwrap<T>(res: unknown): T {
  const data = (res as { data?: unknown })?.data ?? res;
  return ((data as { data?: T })?.data ?? data) as T;
}

export interface SupplierDuplicateCandidate {
  id: string;
  supplier_code: string;
  supplier_name: string;
  tax_registration_number?: string | null;
  email?: string | null;
  match_reasons: string[];
}

export interface SupplierDuplicateCheckResult {
  duplicates: SupplierDuplicateCandidate[];
  has_duplicates: boolean;
}

export async function checkSupplierDuplicates(
  params: {
    supplier_name?: string;
    tax_registration_number?: string;
    vat_number?: string;
    email?: string;
  },
  excludeId?: string
): Promise<SupplierDuplicateCheckResult> {
  const q = new URLSearchParams();
  if (params.supplier_name?.trim()) q.set('supplier_name', params.supplier_name.trim());
  if (params.tax_registration_number?.trim()) {
    q.set('tax_registration_number', params.tax_registration_number.trim());
  }
  if (params.vat_number?.trim()) q.set('vat_number', params.vat_number.trim());
  if (params.email?.trim()) q.set('email', params.email.trim());
  if (excludeId) q.set('exclude_id', excludeId);
  const res = await api.get(`/procurement/suppliers/check-duplicates?${q.toString()}`);
  return unwrap<SupplierDuplicateCheckResult>(res);
}
